import { useTourContext } from "./TourProvider";

export default function useTour() {
  const {
    isOpen,
    currentStep,
    stepIndex,
    steps,
    startTour,
    next,
    back,
    endTour,
  } = useTourContext();

  return {
    isOpen,
    currentStep,
    stepIndex,
    totalSteps: steps.length,
    startTour,
    next,
    back,
    endTour,
  };
}
